import { render, staticRenderFns } from "./PoVendor.vue?vue&type=template&id=72d19d14"
import script from "./PoVendor.vue?vue&type=script&lang=js"
export * from "./PoVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports